export default "/bitrix/js/ui/sign-up/dist/images/initials-active.svg"